import { startCase } from 'lodash';

import { core_apimessages_ProductSpec, core_apimessages_ProductSpec_Type } from './rql';
import { ProductFamilyRouteParams } from './product_family_route_params';

export function shouldDisplayProductFamilyLink(productSpecs: core_apimessages_ProductSpec[]): boolean {
  const productFamily = findProductFamilySpec(productSpecs);
  const hasProductFamilyLink = !!productFamily?.path;

  return hasProductFamilyLink;
}

export function findProductFamilySpec(productSpecs: core_apimessages_ProductSpec[]): core_apimessages_ProductSpec {
  return findAllProductFamilySpecs(productSpecs)[0];
}

export function findAllProductFamilySpecs(productSpecs: core_apimessages_ProductSpec[]): core_apimessages_ProductSpec[] {
  if (!productSpecs) return [];
  return productSpecs.filter((s) => s.type === core_apimessages_ProductSpec_Type.TRAIT && s.name === 'Product Family');
}

export function productFamilyNameFromRoute(routeParams: ProductFamilyRouteParams) {
  return startCase(`${routeParams.brand} ${routeParams.product_family}`);
}

const OMIT_LISTINGS_GRID_SLUGS = [
  'epiphone--les-paul',
  'taylor--baby-taylor',
  'prs--mccarty',
  'prs--silver-sky',
  'prs--custom-24',
  'prs--custom-22',
  'gibson--sg',
  'gibson--l-5',
  'fender--telecaster',
  'fender--stratocaster',
];

export function shouldUseListingsGrid(productFamilySlug) {
  return OMIT_LISTINGS_GRID_SLUGS.indexOf(productFamilySlug) === -1;
}
